import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useIsAccountingCategorySetupRequired = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const query = useRepositorySuspenseQuery(
        'accountingConfigurations',
        'get',
        { enterpriseId },
        { select: ({ accountingConfiguration }) => accountingConfiguration.options.requireAccountingCategorySetup }
    );

    return query.data;
};
